import { Routes } from '@angular/router';

import { authGuard, roleGuard, adminGuard } from '@Guards';
import { sessionGuard } from '../guards/session.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    path: 'login',
    loadComponent: () => import('../pages/login/login.component').then((component) => component.LoginComponent),
  },
  {
    path: 'role',
    loadComponent: () => import('../pages/role/role.component').then((Component) => Component.RoleComponent),
    canActivate: [roleGuard],
  },
  {
    path: 'home',
    loadComponent: () => import('../pages/home/home.component').then((component) => component.HomeComponent),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'accessibility',
    loadComponent: () =>
      import('../pages/accessibility/accessibility.component').then((component) => component.AccessibilityComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'feedback',
    loadComponent: () =>
      import('../pages/feedback/feedback.component').then((component) => component.FeedbackComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'cookies',
    loadComponent: () => import('../pages/cookies/cookies.component').then((component) => component.CookiesComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'info',
    loadComponent: () => import('../pages/info/info.component').then((component) => component.InfoComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'terms',
    loadComponent: () => import('../pages/terms/terms.component').then((component) => component.TermsComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'user-guide',
    loadChildren: () => import('./userGuide.routes').then((routes) => routes.USER_GUIDE_ROUTES),
    canActivate: [sessionGuard],
  },
  {
    path: 'whats-new',
    loadComponent: () =>
      import('../pages/whats-new/whats-new.component').then((Component) => Component.WhatsNewComponent),
    canActivate: [sessionGuard],
  },
  {
    path: 'vaccine-history',
    loadChildren: () => import('./vaccineHistory.routes').then((routes) => routes.VACCINE_HISTORY_PATIENT_ROUTES),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'search',
    loadChildren: () => import('./search.routes').then((routes) => routes.SEARCH_PATIENT_ROUTES),
    canActivate: [authGuard, roleGuard],
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin.routes').then((routes) => routes.ADMIN_ROUTES),
    canActivate: [authGuard, roleGuard, adminGuard],
  },
  {
    path: '**',
    loadComponent: () =>
      import('../pages/not-found/not-found.component').then((Component) => Component.NotFoundComponent),
    canActivate: [authGuard, roleGuard],
  },
];
